@let entities = entities$ | async;

<h2 mat-dialog-title>Planning toevoegen</h2>

<mat-dialog-content>
    @for (entity of entities; track entity.id) {
        @let entityType = entitytypes[entity.entitytypes[0]?.key];

        @if (!activeTypes?.length || activeTypes.includes(entityType.key)) {
            <button [mat-dialog-close]="entity" mat-stroked-button>
                <i class="fal fa-3x {{ entityType?.icon }}"></i>
                <span>{{ entityType?.name }}</span>
            </button>
        }
    }
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Sluiten</button>
</mat-dialog-actions>
